import { CALENDAR_COL, CALENDAR_ROW } from '@link/share/constants';
import type { TableCell } from './MonthlyCalendar.types';

export function getDayCountOfMonth(year: number, month: number) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30;
  }

  if (month === 1) {
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      return 29;
    } else {
      return 28;
    }
  }

  return 31;
}

export function getFirstDayOfMonth(date: Date) {
  const temp = new Date(date.getTime());
  temp.setDate(1);
  return temp.getDay();
}

export function getMonthArray(year: number, month: number) {
  const len = getDayCountOfMonth(year, month);
  return Array.from(Array(len).keys()).map(i => i + 1);
}

export function getDefaultTableCell(): Array<Array<TableCell>> {
  const cells = [];
  const cell: TableCell = {
    value: '',
    title: '',
    week: 'sun'
  };

  for (let i = 0; i < CALENDAR_ROW; i++) {
    const row = [];
    for (let j = 0; j < CALENDAR_COL; j++) {
      row.push({ ...cell });
    }
    cells.push(row);
  }
  return cells;
}
